import type { SavedStopLossOrder } from '@/domain/WorkspaceForex/savedProducts/order/SavedStopLossOrder.ts';
import type { StopLossOrder } from '@/store/orders/stopLoss/state.ts';

export const mapToStopLoss = (savedTile: SavedStopLossOrder): StopLossOrder => {
  return {
    ...savedTile,
    properties: {
      ...savedTile.properties,
    },
  };
};
